import React, { createContext, useState, useContext } from "react";
import PropTypes from "prop-types";
import { useNavigate } from "react-router-dom";
import { authAPI } from "../../api";

export const AuthContext = createContext(null);

export const AuthProvider = ({ children }) => {
  const [user, setUser] = useState(null);
  const navigate = useNavigate();

  const login = async ({ identifier, password }) => {
  try {
    const data = await authAPI.login({ identifier, password });

    if (!data || !data.user || !data.user.statut) {
      throw new Error("Données utilisateur invalides ou statut manquant");
    }
      // Stocker le statut utilisateur
      localStorage.setItem("userStatut", data.user.statut);
      setUser(data.user);

      // Redirection basée sur le statut
      switch (data.user.statut) {
        case "admin":
          navigate("/admin-dashboard");
          break;
        case "assistante":
          navigate("/assistante-dashboard");
          break;
        case "commercial":
          navigate("/commercial-dashboard");
          break;
        default:
          console.error("❌ Statut utilisateur inconnu:", data.user.statut);
          throw new Error("Statut utilisateur inconnu");
      }

      return data.user;
    } catch (error) {
      console.error("❌ Erreur lors de la connexion:", error);
      return null;
    }
  };

  const logout = async () => {
    try {
      await authAPI.logout();
    } catch (error) {
      console.error("❌ Erreur lors de la déconnexion:", error);
    } finally {
      setUser(null);
      localStorage.removeItem("userStatut");
      navigate("/");
    }
  };

  const value = {
    user,
    login,
    logout,
  };

  return <AuthContext.Provider value={value}>{children}</AuthContext.Provider>;
};

AuthProvider.propTypes = {
  children: PropTypes.node.isRequired,
};

export const useAuth = () => {
  const context = useContext(AuthContext);
  if (!context) {
    throw new Error("useAuth doit être utilisé dans un AuthProvider");
  }
  return context;
};

export default AuthProvider;
